





















































































import { Component, Vue } from 'vue-property-decorator'
import axios, { AxiosRequestConfig } from "axios"
import api from "../../api/index"
import Breadcrumb from '../components/Breadcrumb.vue'
import { Action, Getter } from 'vuex-class'
import Box from '../components/Box.vue'
import UserProfileModal from '../components/UserProfileModal.vue'



@Component({
  components: {
    Breadcrumb,
    'box': Box,
    UserProfileModal
  },
})

export default class Admin extends Vue {
  sideBarToggle = false
  currentMq = ""
  currentUser = {
    admin: null
  }
  isUserProfileModalActive = false

  @Action('destroySession') destroySession:any
  @Action('setUserRole') setUserRole:any
  @Action('setUser') setUser:any
  @Getter('admin') admin:any

  get sizeLogo() {
  return this.$mq === 'sm' || this.$mq === 'md' ? '50' : '70'
  }

  get pageClass() {
    return this.$mq
  }

  getMq() {
    this.currentMq = this.$mq
  }

  logout() {
    this.destroySession()
    this.$router.push({name: "login"})
  }

  async mounted() {
    await api.setToken()
    await this.getCurrentUser()
  }

  async getCurrentUser() {
    try {
      const res = await api.get("bo/registration")
      this.currentUser = res.data
      this.setUserRole(this.currentUser.admin)
      this.setUser(this.currentUser)
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status)
      }
    }
  }

  async askImport() {
    try {
      const res = await api.post("bo/import", {})
      this.getCurrentUser()
      this.$toast.open({
          message: 'Drive synchronisé',
          type: 'is-novaccess-purple',
          duration: 2000,
      })
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status)
      }
    }
  }
}
